export class ValidationErrors {
    constructor() {
      this._errors = [];
      this._components = [];
    }
    get hasError() {
      return !!this._errors.find(e => e);
    }
    setError(component, isError) {
      let componentIndex = this._components.indexOf(component);
        if (componentIndex < 0) {
          this._components.push(component);
          componentIndex = this._components.length - 1;
        } 
  
        if (componentIndex >= this._errors.length) {
          this._errors[componentIndex] = isError;
        }
  
        this._errors.splice(componentIndex, 1, isError);
    }
  }
  